export default "__VITE_ASSET__Ch4y9zKA__"